import { motion } from "framer-motion";
import { FiAlertCircle, FiCheckCircle, FiX } from "react-icons/fi";
import SafeIcon from "./SafeIcon";
import type { ConversionStatus, ConverterTheme } from "./types";

interface StatusBannerProps {
  status: ConversionStatus;
  onDismiss: () => void;
  theme: ConverterTheme;
}

const StatusBanner = ({ status, onDismiss, theme }: StatusBannerProps) => {
  if (!status?.message) return null;
  const isError = status.type === "error";

  return (
    <motion.div
      initial={{ opacity: 0, y: -8 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0 }}
      role="alert"
      aria-live="polite"
      className={`flex items-center gap-3 rounded-2xl border p-4 text-sm font-medium ${
        isError
          ? "border-red-200 bg-red-50 text-red-600 dark:border-red-800 dark:bg-red-900/20 dark:text-red-400"
          : "border-emerald-200 bg-emerald-50 text-emerald-700 dark:border-emerald-800 dark:bg-emerald-900/20 dark:text-emerald-400"
      }`}
    >
      <SafeIcon
        icon={isError ? FiAlertCircle : FiCheckCircle}
        className="shrink-0 text-lg"
      />
      <span className="flex-grow">{status.message}</span>
      <button
        type="button"
        onClick={onDismiss}
        aria-label="Dismiss notification"
        className={`shrink-0 rounded p-1 transition-opacity hover:opacity-70 focus-visible:outline-none focus-visible:ring-2 ${theme.focusRing}`}
      >
        <SafeIcon icon={FiX} />
      </button>
    </motion.div>
  );
};

export default StatusBanner;
